/**
 * Shared primary-action button classes for PDF / spreadsheet upload panels
 * inside Procure modals (Quote, Order).
 */
export const PROCURE_PDF_UPLOAD_BTN_CLASS =
  'procure-upload-action-btn procure-upload-action-btn--pdf';

export const PROCURE_SPREADSHEET_UPLOAD_BTN_CLASS =
  'procure-upload-action-btn procure-upload-action-btn--spreadsheet';
